
import { GET } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/audit/${endpoint}`;
};

export const getAllAuditLogs = (token, page, size) => {
  const endpoint = getEndpointWithPrefix(
    `?page=${page}&size=${size}`
  );
  return GET(endpoint, token);
};

export const getAuditLogsByEntity = (token, entityType, entityId, page, size) => {
  const entityIdParam = entityId ? `&entityId=${entityId}` : '';
  const endpoint = getEndpointWithPrefix(
    `${entityType}?page=${page}&size=${size}${entityIdParam}`
  );
  return GET(endpoint, token);
};
